import React, { useState, useRef } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import useOnClickOutside from '../hooks/useOnClickOutside'
import ChevronDown from './svg/chevronDown'

const BidJSMenu = ({ navStyles, subNavStyles }) => {
  const BidJSQuery = useStaticQuery(graphql`
    query BidJSMenuQuery {
      prismicConfig {
        ...PrismicConfigFragment
      }
    }
  `)
  const configData = BidJSQuery.prismicConfig.data

  const ref = useRef()
  useOnClickOutside(ref, () => setAccountOpen(false))

  const [isAccountOpen, setAccountOpen] = useState(false)
  const accountToggle = () => setAccountOpen(!isAccountOpen)

  return (
    <li ref={ref} className='x-bidlogix--authenticated-show relative ml-auto hidden'>
      <button aria-expanded={isAccountOpen} aria-haspopup='true' className={navStyles} onClick={accountToggle} onKeyDown={accountToggle}>
        <div className='mr-2 rounded-full border border-gray-300 bg-gray-50 p-px'>
          <svg xmlns='http://www.w3.org/2000/svg' className='h-6 w-6 text-gray-500' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={1}
              d='M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z'
            />
          </svg>
        </div>
        {configData.my_account || 'My Account'}

        <div className='ml-1 text-orange-500'>
          <ChevronDown />
        </div>
      </button>
      <ul className={`${!isAccountOpen ? 'hidden' : 'flex min-w-max flex-col bg-gray-50 lg:absolute lg:right-0 lg:mt-2 lg:rounded lg:bg-white lg:p-3 lg:shadow-md'}`}>
        <li key='settings'>
          <a href='/auction/#!/account' className={subNavStyles} onClick={() => accountToggle()}>
            {configData.my_settings || 'My Settings'}
          </a>
        </li>
        <li key='invoice'>
          <a href='/auction/#!/invoices' className={subNavStyles} onClick={() => accountToggle()}>
            {configData.my_invoices || 'My Invoices'}
          </a>
        </li>
        <li key='auctionsArchived'>
          <a className={subNavStyles} href='/auction/#!/auctionsArchived' onClick={() => accountToggle()}>
            {configData.archived_auctions || 'Archived Auctions'}
          </a>
        </li>
        <li key='sales' className='x-bidlogix--vendor-show hidden'>
          <a className={subNavStyles} href='/auction/#!/mySales' onClick={() => accountToggle()}>
            {configData.my_sales || 'My Sales'}
          </a>
        </li>
        <li key='highBids' className='x-bidlogix--authenticated-show hidden'>
          <a className={subNavStyles} href='/auction/#!/highBids' onClick={() => accountToggle()}>
            {configData.my_high_bids || 'My High Bids'}
          </a>
        </li>
        <li key='admin' className='x-bidlogix--administrator-show hidden'>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a className={subNavStyles} href='#' target='_blank' rel='noopener noreferrer' onClick={() => accountToggle()}>
            {configData.admin || 'Admin'}
          </a>
        </li>
        <li key='seperator' className='my-2 border-t' role='separator'></li>
        <li key='logout'>
          <a href='/#!/logout' className={`${subNavStyles} justify-between`} onClick={() => accountToggle()}>
            {configData.log_out || 'Log Out'}
            <svg xmlns='http://www.w3.org/2000/svg' className='ml-1 h-5 w-5 text-gray-500' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1' />
            </svg>
          </a>
        </li>
      </ul>
    </li>
  )
}

export default BidJSMenu
